export default __webpack_public_path__ + "static/BPA Welling-a3d84a356a5d008b4f53323eba365ff8.png";